import { api } from '../api'

export interface BraintreeToken {
  token: {
    data: string
    statusCode: number
  }
}

export interface BraintreeTokenRequestParameters {
  campaignId: string // Note pay actually uses appId. We make some extra requests to derive this from cid.
  currency: string
  [key: string]: string
}

const braintreeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBraintreeToken: builder.query<BraintreeToken, BraintreeTokenRequestParameters>({
      query: ({ campaignId, currency }) => ({
        url: `/token/braintree?campaignId=${campaignId}&currency=${currency}`,
      }),
    }),
  }),
})

export const {
  endpoints: { getBraintreeToken },
} = braintreeApi

export default braintreeApi
